/* global axios */

import ApiClient from './ApiClient';

class CalendarEventsAPI extends ApiClient {
  constructor() {
    super('calendar_events', { accountScoped: true });
  }

  getEvents({ from, to } = {}) {
    return axios.get(this.url, { params: { from, to } });
  }

  createEvent(data) {
    return axios.post(this.url, { calendar_event: data });
  }

  updateEvent(eventId, data) {
    return axios.patch(`${this.url}/${eventId}`, { calendar_event: data });
  }

  deleteEvent(eventId) {
    return axios.delete(`${this.url}/${eventId}`);
  }
}

export default new CalendarEventsAPI();
